import React, { isValidElement, useState } from 'react'
import { Box, BoxProps, Collapse, css, Divider, styled } from '@mui/material'

import { CollapseArrow } from '~/components/elements/CollapseArrow/CollapseArrow'

import Typography from '../Typography/Typography'

const StyledValue = styled(Typography.Paragraph)`
  margin-left: auto;
`

const StyledTitleValue = styled(Typography.H3)`
  margin-left: auto;
`

const StyledDivider = styled(Divider, {
  shouldForwardProp: (props) => props !== 'border',
})`
  position: absolute;
  top: 0;
  ${({ border }: { border?: BorderProps }) =>
    border
      ? css`
          right: ${border.position};
          border-color: ${border.color};
        `
      : ''}
`

type BorderProps = {
  color?: string
  position: string
}

interface CollapsibleInformationListProps {
  ContainerProps?: BoxProps
  border?: BorderProps
  initiallyOpened?: boolean
  list: { id: string; label: React.ReactNode; value: string }[]
  title: string
  titleValue: string
}

export const CollapsibleInformationList = ({
  ContainerProps,
  border,
  initiallyOpened,
  title,
  titleValue,
  list,
}: CollapsibleInformationListProps) => {
  const [open, setOpen] = useState(initiallyOpened)

  const handleOpen = () => setOpen(!open)

  return (
    <Box position="relative" {...ContainerProps}>
      <Collapse in={open}>
        {list.map(({ id, label, value }) => (
          <Box display="flex" key={id} ml={3}>
            {isValidElement(label) ? (
              label
            ) : (
              <Typography.Paragraph>{label}</Typography.Paragraph>
            )}
            <StyledValue>{value}</StyledValue>
          </Box>
        ))}
      </Collapse>
      <Box
        alignItems="center"
        display="flex"
        sx={{ cursor: 'pointer' }}
        onClick={handleOpen}
      >
        <CollapseArrow expanded={open} />
        <Typography.H3 color="grayGray1">{title}</Typography.H3>
        <StyledTitleValue color="grayGray1">{titleValue}</StyledTitleValue>
      </Box>
      {Boolean(border) && (
        <StyledDivider border={border} orientation="vertical" />
      )}
    </Box>
  )
}
